import styled from 'styled-components';

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${props => props.zIndex ? props.zIndex : 1};
`;

export const ModalContainer = styled.div`
    background-color: #fff;
    padding: 24px;
    border-radius: 12px;

    /* Se fullWidth for true, usa 100%. Senão, avalia se tem maxWidth numérico ou assume 500px */
    max-width: ${props => props.fullWidth ? '100%' : (props.maxWidth ? props.maxWidth + 'px' : '500px')};
    max-height: ${props => props.maxHeight ? props.maxHeight + 'px' : 'none'};
    overflow-y: ${props => props.withOverflowY ? 'auto' : 'none'};

    /* Se fullWidth for true, ocupa 100% sem a margem dos 90% */
    width: ${props => props.fullWidth ? '100%' : '90%'};

    box-sizing: border-box;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
    position: relative;
    animation: fadeIn 0.3s ease-out;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    background: transparent;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    line-height: 1;

    &:hover {
        color: #000;
    }
`;